import { jsx } from 'react/jsx-runtime';
import { useComposedRefs } from '@radix-ui/react-compose-refs';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { useModalContext } from '../../context.mjs';
import { StyledTitle } from '../../styled.mjs';
import { title } from './title.vanilla.mjs';

const ModalTitle = forwardRef(
  ({ className: classNameFromProps, ...props }, ref) => {
    const { onTitleChange } = useModalContext("ModalHeader");
    const composedRef = useComposedRefs(ref, onTitleChange);
    const className = classNames(title, classNameFromProps);
    return /* @__PURE__ */ jsx(StyledTitle, { className, ref: composedRef, ...props });
  }
);

export { ModalTitle };
//# sourceMappingURL=Title.mjs.map
